var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeaturesLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 700,
    viewBox: "0 0 1920 700",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_66_122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1953.28 236.5C1961.05 673.127 23.7793 -184 -16.2217 236.5C-56.2228 657 -16.2217 131 -16.2217 79.75V-77L1949.86 -43.059C1950.22 -104.884 1953.28 -43 1953.28 -43L1949.86 -43.059C1949.65 -6.36938 1950.39 73.8875 1953.28 236.5Z",
    fill: "#F50057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1953.28 299.5C1961.05 736.127 23.7793 -121 -16.2217 299.5C-56.2228 720 -16.2217 194 -16.2217 142.75V-14L1949.86 19.941C1950.22 -41.8838 1953.28 20 1953.28 20L1949.86 19.941C1949.65 56.6306 1950.39 136.887 1953.28 299.5Z",
    fill: "#F50057",
    fillOpacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1953.28 358.5C1961.05 795.127 23.7793 -62.0002 -16.2217 358.5C-56.2228 779 -16.2217 253 -16.2217 201.75V45L1949.86 78.941C1950.22 17.1162 1953.28 79 1953.28 79L1949.86 78.941C1949.65 115.631 1950.39 195.887 1953.28 358.5Z",
    fill: "#F50057",
    fillOpacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1965.28 413.5C1973.05 850.127 35.7793 -7.00024 -4.22175 413.5C-44.2228 834 -4.22175 308 -4.22175 256.75V100L1961.86 133.941C1962.22 72.1162 1965.28 134 1965.28 134L1961.86 133.941C1961.65 170.631 1962.39 250.887 1965.28 413.5Z",
    fill: "#F50057",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1964.98 478.765C1972.74 984.006 35.7705 -7.81487 -4.22445 478.765C-44.2194 965.345 -4.22445 356.686 -4.22445 297.383V116L1961.56 155.275C1961.92 83.7344 1964.98 155.343 1964.98 155.343L1961.56 155.275C1961.35 197.73 1962.08 290.599 1964.98 478.765Z",
    fill: "#F50057",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1941.98 610.51C1949.74 1321.52 12.7705 -74.2413 -27.2245 610.51C-67.2194 1295.26 -27.2245 438.711 -27.2245 355.255V100L1938.56 155.27C1938.92 54.5935 1941.98 155.366 1941.98 155.366L1938.56 155.27C1938.35 215.016 1939.08 345.708 1941.98 610.51Z",
    fill: "#F50057",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1932.98 758.254C1940.74 1675.04 3.77053 -124.668 -36.2245 758.254C-76.2194 1641.18 -36.2245 536.736 -36.2245 429.127V100L1929.56 171.266C1929.92 41.4527 1932.98 171.39 1932.98 171.39L1929.56 171.266C1929.35 248.303 1930.08 416.818 1932.98 758.254Z",
    fill: "#F50057",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1937.98 973.254C1945.74 1890.04 8.77053 90.3323 -31.2245 973.254C-71.2194 1856.18 -31.2245 751.736 -31.2245 644.127C-31.2245 536.518 1 -17 1 -17H1970C1970 -17 1930.21 56.471 1937.98 973.254Z",
    fill: "#F50057",
    fillOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_66_122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 700,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesLight);
export default __webpack_public_path__ + "static/media/featuresLight.a50bb0f4f0d3fc6c87df815160a35515.svg";
export { ForwardRef as ReactComponent };